import Slider from "react-slick";

import { useState, useEffect, createRef } from 'react';
import testimonialOne from '../assets/images/user.png';
import { fetchTestimonials } from '../services/apiService';

const Testimonials = () => {


    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);


    //creating the ref
    const customeSlider = createRef();

    // setting slider configurations
    const [sliderSettings] = useState({
        infinite: true,
        dots: false,
        speed: 500,
        slidesToShow: 3, // mobile default
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        mobileFirst: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600, // ≥600px (tablet)
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 992, // ≥992px (desktop)
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 3840, // ≥992px (desktop)
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    useEffect(() => {
        const loadTestimonials = async () => {
            try {
                const response = await fetchTestimonials();
                if (response.success && response.data && response.data.data) {
                    setTestimonials(response.data.data);
                }
            } catch (error) {
                console.error('Error loading testimonials:', error);
            } finally {
                setLoading(false);
            }
        };

        loadTestimonials();
        window.dispatchEvent(new Event("resize"));
    }, []);


    return (
        <div>
            <h1 className="outline-text testimonials-section-title custom-size">“Client <br /> Testimonials”</h1>            {loading ? (
                <div className="text-center py-5">
                    <i className="fa-solid fa-spinner fa-spin text-white" style={{ fontSize: '2rem' }}></i>
                </div>
            ) : testimonials.length > 0 ? (            <Slider {...sliderSettings} ref={customeSlider}>

                {
                    testimonials.map((testimonialItem => (

                        <div className="testimonial-card" key={testimonialItem.si}>
                            <div className="testimonial-user">
                                <img
                                    src={testimonialOne}
                                    className="user-img"
                                    alt={`${testimonialItem.client || 'testimonial'}-img`}
                                />
                                <p className="testimonial-description mt-4">"{testimonialItem.message}"</p>

                            </div>

                            <div className="user-info">
                                <h2 className="user-name">{testimonialItem.client || "Client"}</h2>
                                <p className="user-designation">{testimonialItem.company || "Company"}</p>
                            </div>
                        </div>

                    )))
                }

            </Slider>            ) : (
                <div className="text-center py-5">
                    <p className="text-white">No testimonials available at the moment.</p>
                </div>
            )}        </div>
    )
};

export default Testimonials;